import { useSelector } from 'react-redux';
import { getCanCreateDragDropEmail, getHasFullDashboardAccess, getHasSoftLimitScope, getHasTransactionSmtpAccess, getIsHubSpotter
// @ts-expect-error not migrate to TS yet
} from 'EmailData/selectors/user';
import AdditionalMoreToolsContent from './AdditionalMoreToolsContent';
import PortalIdParser from 'PortalIdParser';
import { jsx as _jsx } from "react/jsx-runtime";
const AdditionalMoreToolsContainer = props => {
  const portalId = PortalIdParser.get();
  const hasSoftLimit = useSelector(getHasSoftLimitScope);
  const isHubSpotter = useSelector(getIsHubSpotter);
  const canCreateDragDropEmail = useSelector(getCanCreateDragDropEmail);
  const hasFullDashboardAccess = useSelector(getHasFullDashboardAccess);
  const hasTransactionalSMTP = useSelector(getHasTransactionSmtpAccess);
  return /*#__PURE__*/_jsx(AdditionalMoreToolsContent, Object.assign({
    canCreateDragDropEmail: canCreateDragDropEmail,
    hasFullDashboardAccess: hasFullDashboardAccess,
    hasSoftLimit: hasSoftLimit,
    hasTransactionalSMTP: hasTransactionalSMTP,
    isHubSpotter: isHubSpotter,
    portalId: portalId
  }, props));
};
export default AdditionalMoreToolsContainer;